'use strict';

var PhotoSwipe = require('photoswipe/dist/photoswipe.js');
var PhotoSwipeUIDefault = require('photoswipe/dist/photoswipe-ui-default.js');

module.exports = {
	initPhotoSwipeFromDOM: function (gallerySelector) {
		// parse slide data (url, title, size ...) from DOM elements
		// (children of gallerySelector)
		var parseThumbnailElements = function (el) {
			var thumbElements = el.childNodes,
				numNodes = thumbElements.length,
				items = [],
				figureEl,
				linkEl,
				size,
				item;

			for (var i = 0; i < numNodes; i++) {
				figureEl = thumbElements[i]; // <figure> element

				// include only element nodes
				if (figureEl.nodeType !== 1) {
					continue; // eslint-disable-line
				}

				linkEl = figureEl.children[0]; // <a> element

				size = linkEl.getAttribute('data-size').split('x');

				// create slide object
				item = {
					src: linkEl.getAttribute('href'),
					w: parseInt(size[0], 10),
					h: parseInt(size[1], 10)
				};

				if (figureEl.children.length > 1) {
					// <figcaption> content
					item.title = figureEl.children[1].innerHTML;
				}

				if (linkEl.children.length > 0) {
					// <img> thumbnail element, retrieving thumbnail url
					item.msrc = linkEl.children[0].getAttribute('src');
				}

				item.el = figureEl; // save link to element for getThumbBoundsFn
				items.push(item);
			}

			return items;
		};

		// find nearest parent element
		var closest = function closest(el, fn) {
			return el && (fn(el) ? el : closest(el.parentNode, fn));
		};

		// triggers when user clicks on thumbnail
		var onThumbnailsClick = function (event) {
			var e = event || window.event;
			e.preventDefault ? e.preventDefault() : e.returnValue = false; // eslint-disable-line
			var eTarget = e.target || e.srcElement;

			// find root element of slide
			var clickedListItem = closest(eTarget, function (el) {
				return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
			});

			if (!clickedListItem) {
				return;
			}

			// find index of clicked item by looping through all child nodes
			// alternatively, you may define index via data- attribute
			var clickedGallery = clickedListItem.parentNode,
				childNodes = clickedListItem.parentNode.childNodes,
				numChildNodes = childNodes.length,
				nodeIndex = 0,
				index;

			for (var i = 0; i < numChildNodes; i++) {
				if (childNodes[i].nodeType !== 1) {
					continue; // eslint-disable-line
				}

				if (childNodes[i] === clickedListItem) {
					index = nodeIndex;
					break;
				}
				nodeIndex++;
			}


			if (index >= 0) {
				// open PhotoSwipe if valid index found
				openPhotoSwipe(index, clickedGallery); // eslint-disable-line
			}
		};

		// parse picture index and gallery index from URL (${'#'}&pid=1&gid=2)
		var photoswipeParseHash = function () {
			var hash = window.location.hash.substring(1),
				params = {};

			if (hash.length < 5) {
				return params;
			}

			var vars = hash.split('&');
			for (var i = 0; i < vars.length; i++) {
				if (!vars[i]) {
					continue; // eslint-disable-line
				}
				var pair = vars[i].split('=');
				if (pair.length < 2) {
					continue; // eslint-disable-line
				}
				params[pair[0]] = pair[1];
			}

			if (params.gid) {
				params.gid = parseInt(params.gid, 10);
			}

			return params;
		};

		var openPhotoSwipe = function (i, galleryElement, disableAnimation, fromURL) {
			$('body').addClass('photoSwipeOpen');
			$('body').trigger('toggleScroll', 'lock');
			var pswpElement = document.querySelectorAll('.pswp')[0],
				index = i,
				gallery,
				options,
				items;
			items = parseThumbnailElements(galleryElement);

			// define options (if needed)
			options = {
				// define gallery index (for URL)
				galleryUID: galleryElement.getAttribute('data-pswp-uid'),

				getThumbBoundsFn: function (index) { // eslint-disable-line
					// See Options -> getThumbBoundsFn section of documentation for more info
					var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
						pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
						rect = thumbnail.getBoundingClientRect();

					return {
						x: rect.left,
						y: rect.top + pageYScroll,
						w: rect.width
					};
				}
			};

			// PhotoSwipe opened from URL
			if (fromURL) {
				if (options.galleryPIDs) {
					// parse real index when custom PIDs are used
					// http://photoswipe.com/documentation/faq.html${'#'}custom-pid-in-url
					for (var j = 0; j < items.length; j++) {
						if (items[j].pid === index) {
							options.index = j;
							break;
						}
					}
				} else {
					// in URL indexes start from 1
					options.index = parseInt(index, 10) - 1;
				}
			} else {
				options.index = parseInt(index, 10);
			}

			// exit if index not found
			if (isNaN(options.index)) {
				return;
			}

			if (disableAnimation) {
				options.showAnimationDuration = 0;
			}

			// Pass data to PhotoSwipe and initialize it
			gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, options);
			gallery.init();

			gallery.listen('close', function () {
				setTimeout(function () {
					$('body').removeClass('photoSwipeOpen');
					$('body').trigger('toggleScroll', 'unlock');
				}, 500); // Swipe close animation duration = 333
			});

            // This is needed so the Swiper slider behind the photoswipe gallery slides along with the photoswipe gallery
			gallery.listen('afterChange', function () {
				var curr = gallery.currItem;
				var slideIndex = curr.el.dataset.swiperIndex;
				var productSwiper = $('.js-pdp-slider');
				var storeSwiper = $('.js-store-slider');

				if ( productSwiper.length ) {
					productSwiper[0].swiper.slideTo(slideIndex);
				}

				if ( storeSwiper.length ) {
					storeSwiper[0].swiper.slideTo(slideIndex);
				}
			});

			// For IE11 users on products with unequal width/height
			gallery.listen('initialZoomInEnd', function () {
				var img = document.querySelector('img.pswp__img');
				if (!img) return;
				var computedStyle = getComputedStyle(img).objectFit;
				var objectFitSupport = !!computedStyle;
				if (objectFitSupport) return;

				if (!img.naturalHeight || !img.naturalWidth) return;
				if (img.naturalWidth === img.naturalHeight) return;
				if (img.naturalWidth > img.naturalHeight) img.style.width = '';
				if (img.naturalWidth < img.naturalHeight) img.style.height = '';

				if (window.MutationObserver) {
					var config = { attributes: true };
					var observer = new MutationObserver(function (mutations) {
						for (var mi = 0; mi < mutations.length; mi++) {
							var mutation = mutations[mi];
							if (mutation.attributeName === 'style') {
								if (img.style.width && img.style.height) {
									if (img.naturalWidth > img.naturalHeight) img.style.width = '';
									if (img.naturalWidth < img.naturalHeight) img.style.height = '';
								}
								break;
							}
						}
					});
					observer.observe(img, config);

					gallery.listen('destroy', function () {
						observer.disconnect();
					});
				}
			});
		};

		// If on Android, also open photoswipe on pinch zoom
		if ($('html[data-useragent*="Android"]')[0]) {
			var touchPosStart,
				ptspOpen = false,
				$mainImagesSlider = $('.js-pdp-slider'); // using the data attribute seems to give some problems?

			$mainImagesSlider.on('touchstart', function (e) {
				if (e.touches.length > 1) {
					touchPosStart = Math.sqrt(
						(e.touches[0].pageX - e.touches[1].pageX) * (e.touches[0].pageX - e.touches[1].pageX) + // eslint-disable-line
						(e.touches[0].pageY - e.touches[1].pageY) * (e.touches[0].pageY - e.touches[1].pageY)); // eslint-disable-line
				}
			});

			$mainImagesSlider.on('touchMove', function (e) {
				if (e.touches.length > 1) {
					var touchDistance = Math.sqrt(
						(e.touches[0].pageX - e.touches[1].pageX) * (e.touches[0].pageX - e.touches[1].pageX) + // eslint-disable-line
						(e.touches[0].pageY - e.touches[1].pageY) * (e.touches[0].pageY - e.touches[1].pageY)); // eslint-disable-line

					if (touchDistance > touchPosStart) {
						if (!ptspOpen) {
							var $slider = $mainImagesSlider.find('.swiper-wrapper'),
							activeSlideIndex = $slider.eq(0).find('.swiper-slide-active').index();

							ptspOpen = true;

							setTimeout(function () {
								ptspOpen = false;
							}, 500);

							openPhotoSwipe(activeSlideIndex, $slider[0]);
						}
					}
				}
			});
		}

		// loop through all gallery elements and bind events
		var galleryElements = document.querySelectorAll(gallerySelector);

		for (var i = 0, l = galleryElements.length; i < l; i++) {
			galleryElements[i].setAttribute('data-pswp-uid', i + 1);
			galleryElements[i].onclick = onThumbnailsClick;
		}

		// Parse URL and open gallery if it contains #&pid=3&gid=1
		var hashData = photoswipeParseHash();
		if (hashData.pid && hashData.gid) {
			openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
		}
	}
};
